export interface VideoItem {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  poster: string;
  year: number;
  rating: number;
  description: string;
  director: string;
  actors: string[];
  region: string;
  episodes: number | string;
  status: string;
  updateInfo: string;
  tags: string[];
  views: number;
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { name: '电视剧', slug: 'dianshiju', icon: 'ri-tv-line' },
  { name: '电影', slug: 'dianying', icon: 'ri-film-line' },
  { name: '综艺', slug: 'zongyi', icon: 'ri-live-line' },
  { name: '动漫', slug: 'dongman', icon: 'ri-emotion-line' },
];

export const heroVideos: VideoItem[] = [
  {
    id: 'v1',
    title: '长风渡',
    category: '电视剧',
    categorySlug: 'dianshiju',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20elegant%20ancient%20couple%20in%20traditional%20hanfu%20robes%2C%20warm%20golden%20and%20crimson%20tones%2C%20ink%20wash%20painting%20style%20background%2C%20cinematic%20lighting%2C%20romantic%20atmosphere%2C%20movie%20poster%20quality&width=800&height=1120&seq=hero-1&orientation=portrait',
    year: 2023,
    rating: 8.5,
    description: '讲述了布商之女柳玉茹与纨绔子弟顾九思阴差阳错结为夫妻，从相互抵触到相知相守，在乱世中共同成长的故事。剧情扣人心弦，演员演技在线，是一部不可错过的古装佳作。',
    director: '尹涛',
    actors: ['白敬亭', '宋轶', '刘学义', '张昊唯'],
    region: '中国大陆',
    episodes: 40,
    status: '已完结',
    updateInfo: '全40集',
    tags: ['古装', '爱情', '权谋', '成长'],
    views: 12800000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'v2',
    title: '繁城之下',
    category: '电视剧',
    categorySlug: 'dianshiju',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20drama%20poster%20dark%20moody%20atmosphere%2C%20ancient%20city%20night%20scene%20with%20lanterns%2C%20detective%20theme%2C%20suspenseful%20cinematic%20composition%2C%20film%20noir%20style%20with%20traditional%20Chinese%20elements&width=800&height=1120&seq=hero-2&orientation=portrait',
    year: 2023,
    rating: 8.8,
    description: '明朝万历年间，江南蠹县接连发生凶案，小捕快曲三更携手典史宋辰、同伴高士聪等人展开调查，揭开二十年前灭门惨案真相。层层反转，烧脑悬疑。',
    director: '王铮',
    actors: ['宁理', '白宇帆', '向涵之', '刘怡潼'],
    region: '中国大陆',
    episodes: 12,
    status: '已完结',
    updateInfo: '全12集',
    tags: ['悬疑', '古装', '探案', '烧脑'],
    views: 9600000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'v3',
    title: '流浪地球3',
    category: '电影',
    categorySlug: 'dianying',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20blockbuster%20movie%20poster%2C%20futuristic%20space%20station%20and%20earth%2C%20epic%20scale%2C%20dramatic%20lighting%2C%20cinematic%20movie%20poster%20quality%2C%20warm%20orange%20and%20deep%20blue%20color%20scheme&width=800&height=1120&seq=hero-3&orientation=portrait',
    year: 2025,
    rating: 8.2,
    description: '太阳急速老化，持续膨胀，地球面临被吞没的灭顶之灾。人类再次踏上未知的旅程，为了生存而战。视觉效果震撼，中国科幻电影的里程碑之作。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    region: '中国大陆',
    episodes: 1,
    status: '已上映',
    updateInfo: '高清完整版',
    tags: ['科幻', '灾难', '冒险', '3D'],
    views: 25600000,
    isHot: true,
    isNew: true,
  },
];

export const allVideos: VideoItem[] = [
  ...heroVideos,
  {
    id: 'v4',
    title: '庆余年第二季',
    category: '电视剧',
    categorySlug: 'dianshiju',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%2C%20handsome%20male%20lead%20in%20traditional%20robes%2C%20palace%20intrigue%20theme%2C%20golden%20and%20deep%20red%20color%20palette%2C%20cinematic%20composition&width=800&height=1120&seq=v4&orientation=portrait',
    year: 2024,
    rating: 9.1,
    description: '范闲归来，京都风云再起。面对更加复杂的朝堂局势和江湖恩怨，范闲将如何守护身边的人？第二季全面升级，剧情更加紧凑精彩。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    region: '中国大陆',
    episodes: 36,
    status: '已完结',
    updateInfo: '全36集',
    tags: ['古装', '权谋', '喜剧', '热血'],
    views: 32000000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'v5',
    title: '满江红',
    category: '电影',
    categorySlug: 'dianying',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20film%20poster%2C%20Song%20dynasty%20setting%2C%20group%20of%20soldiers%20in%20courtyard%2C%20dark%20and%20moody%20lighting%2C%20red%20accents%2C%20cinematic%20movie%20poster%20quality&width=800&height=1120&seq=v5&orientation=portrait',
    year: 2023,
    rating: 7.8,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一群小人物前赴后继，用生命与奸臣博弈。多重反转，笑中带泪，张艺谋导演又一力作。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    region: '中国大陆',
    episodes: 1,
    status: '已上映',
    updateInfo: '4K超清版',
    tags: ['历史', '悬疑', '喜剧', '剧情'],
    views: 45000000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'v6',
    title: '披荆斩棘的哥哥第三季',
    category: '综艺',
    categorySlug: 'zongyi',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20male%20celebrities%20on%20stage%2C%20colorful%20concert%20lighting%2C%20energetic%20atmosphere%2C%20modern%20stage%20design%2C%20entertainment%20show%20style&width=800&height=1120&seq=v6&orientation=portrait',
    year: 2024,
    rating: 8.7,
    description: '32位不同年代的哥哥齐聚舞台，用汗水和才华诠释"滚烫人生"。经典歌曲全新演绎，舞台效果炸裂，口碑爆棚的国民综艺。',
    director: '芒果TV',
    actors: ['陈楚生', '林志颖', '胡彦斌', '王耀庆'],
    region: '中国大陆',
    episodes: '更新中',
    status: '热播中',
    updateInfo: '更新至第8期',
    tags: ['音乐', '竞演', '真人秀', '舞台'],
    views: 18900000,
    isHot: true,
    isNew: true,
  },
  {
    id: 'v7',
    title: '凡人修仙传',
    category: '动漫',
    categorySlug: 'dongman',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20donghua%20poster%2C%20cultivation%20immortal%20theme%2C%20young%20male%20protagonist%20with%20sword%2C%20fantasy%20landscape%20with%20floating%20mountains%2C%20epic%20scale%2C%20warm%20lighting&width=800&height=1120&seq=v7&orientation=portrait',
    year: 2023,
    rating: 9.3,
    description: '平凡少年韩立出身贫寒，为改变命运踏上修仙之路。凭借谨慎的性格和过人的智慧，在尔虞我诈的修仙界中步步为营，最终成就大道。国漫巅峰之作！',
    director: '王裕仁',
    actors: ['张杰', '杨天翔', '季冠霖'],
    region: '中国大陆',
    episodes: 72,
    status: '已完结',
    updateInfo: '全72集',
    tags: ['玄幻', '修仙', '热血', '3D国漫'],
    views: 15200000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'v8',
    title: '年会不能停',
    category: '电影',
    categorySlug: 'dianying',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20film%20poster%2C%20modern%20office%20workers%20at%20company%20annual%20party%2C%20funny%20chaotic%20scene%2C%20colorful%20party%20decorations%2C%20warm%20and%20humorous%20atmosphere&width=800&height=1120&seq=v8&orientation=portrait',
    year: 2023,
    rating: 8.9,
    description: '钳工胡建林阴差阳错被调入集团总部，在年会上引发一连串啼笑皆非的故事。打工人必看神作，笑点密集，讽刺辛辣，年度最佳喜剧电影！',
    director: '董润年',
    actors: ['大鹏', '白客', '庄达菲', '王迅'],
    region: '中国大陆',
    episodes: 1,
    status: '已上映',
    updateInfo: '高清完整版',
    tags: ['喜剧', '职场', '讽刺', '温情'],
    views: 38000000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'v9',
    title: '莲花楼',
    category: '电视剧',
    categorySlug: 'dianshiju',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20poster%2C%20handsome%20male%20lead%20in%20white%20robes%20with%20sword%2C%20ancient%20Chinese%20landscape%20background%2C%20mysterious%20atmosphere%2C%20ink%20wash%20painting%20style&width=800&height=1120&seq=v9&orientation=portrait',
    year: 2023,
    rating: 8.6,
    description: '十年前四顾门门主李相夷与金鸳盟盟主笛飞声东海一战，两人双双失踪。十年后李莲花游历江湖，接连遇到故人，十年前真相渐渐浮出水面。',
    director: '郭虎',
    actors: ['成毅', '曾舜晞', '肖顺尧', '陈都灵'],
    region: '中国大陆',
    episodes: 40,
    status: '已完结',
    updateInfo: '全40集',
    tags: ['武侠', '悬疑', '探案', '江湖'],
    views: 11200000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'v10',
    title: '你好星期六',
    category: '综艺',
    categorySlug: 'zongyi',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20talk%20show%20poster%2C%20colorful%20studio%20set%20with%20hosts%20and%20guests%2C%20bright%20and%20cheerful%20atmosphere%2C%20entertainment%20show%20style%2C%20modern%20TV%20studio&width=800&height=1120&seq=v10&orientation=portrait',
    year: 2024,
    rating: 8.3,
    description: '国内最火爆的周末综艺，每周六准时带来欢笑。明星嘉宾游戏互动，精彩才艺表演，温暖治愈的欢乐时光。',
    director: '湖南卫视',
    actors: ['何炅', '李雪琴', '檀健次', '秦霄贤'],
    region: '中国大陆',
    episodes: '更新中',
    status: '热播中',
    updateInfo: '每周六更新',
    tags: ['综艺', '游戏', '搞笑', '访谈'],
    views: 22000000,
    isHot: false,
    isNew: true,
  },
  {
    id: 'v11',
    title: '斗破苍穹',
    category: '动漫',
    categorySlug: 'dongman',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20donghua%20poster%2C%20young%20warrior%20with%20flame%20powers%2C%20fantasy%20desert%20landscape%2C%20epic%20battle%20scene%2C%20vibrant%20warm%20colors%2C%20dynamic%20composition&width=800&height=1120&seq=v11&orientation=portrait',
    year: 2023,
    rating: 9.0,
    description: '天才少年萧炎在创造了家族空前的修炼纪录后遭遇巨大打击，在药老指导下重新崛起。华丽特效，热血战斗，不可错过的国漫经典。',
    director: '赵侠',
    actors: ['张杰', '季冠霖', '乔诗语'],
    region: '中国大陆',
    episodes: 104,
    status: '已完结',
    updateInfo: '全104集',
    tags: ['玄幻', '热血', '战斗', '3D国漫'],
    views: 18500000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'v12',
    title: '飞驰人生2',
    category: '电影',
    categorySlug: 'dianying',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20film%20poster%2C%20rally%20car%20in%20desert%20landscape%2C%20dust%20and%20speed%2C%20cinematic%20action%20composition%2C%20warm%20desert%20tones%2C%20dynamic%20motion%20blur&width=800&height=1120&seq=v12&orientation=portrait',
    year: 2024,
    rating: 7.9,
    description: '昔日冠军车手张驰沦为落魄驾校教练，偶然间得到重回赛场的机会。笑中带泪的赛车故事，沈腾再度演绎中年男人的热血逆袭。',
    director: '韩寒',
    actors: ['沈腾', '范丞丞', '尹正', '张本煜'],
    region: '中国大陆',
    episodes: 1,
    status: '已上映',
    updateInfo: '高清完整版',
    tags: ['喜剧', '赛车', '励志', '动作'],
    views: 31000000,
    isHot: false,
    isNew: false,
  },
];

export const aboutInfo = {
  brandName: '棒棒TV',
  tagline: '好剧好电影，尽在棒棒TV',
  description: '棒棒TV成立于2020年，致力于为广大影视爱好者提供海量高清影视内容的在线观看服务。我们汇集了全球最新最热的电视剧、电影、综艺节目和动漫作品，覆盖中国大陆、港台、日韩、欧美等多个地区的优质内容。',
  features: [
    {
      title: '海量片库',
      description: '拥有超过10万部影视作品，涵盖电视剧、电影、综艺、动漫等多种类型，从经典老片到最新热播，应有尽有。',
      icon: 'ri-stack-line',
    },
    {
      title: '高清流畅',
      description: '支持4K超清画质，采用全球CDN加速技术，确保观影过程不卡顿、不缓冲，享受丝滑观影体验。',
      icon: 'ri-4k-line',
    },
    {
      title: '更新及时',
      description: '热门剧集同步更新，第一时间为您奉上最新内容，再也不用担心错过精彩剧情。',
      icon: 'ri-flashlight-line',
    },
    {
      title: '纯净观影',
      description: '无弹窗广告干扰，界面简洁清爽，为您打造沉浸式观影环境。',
      icon: 'ri-shield-check-line',
    },
  ],
  reputation: [
    {
      name: '张先生',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20portrait%20photo%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-1&orientation=squarish',
      comment: '棒棒TV的画质真的是我见过的最好的，看剧完全不会卡，而且更新速度超快，追剧党的福音！',
      rating: 5,
    },
    {
      name: '李女士',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20portrait%20photo%2C%20warm%20smile%2C%20clean%20white%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-2&orientation=squarish',
      comment: '片库超级全，想看的剧基本都能找到。界面也很清爽，没有乱七八糟的广告，体验很好。',
      rating: 5,
    },
    {
      name: '王先生',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20portrait%20photo%2C%20confident%20expression%2C%20clean%20white%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-3&orientation=squarish',
      comment: '每天晚上都会打开棒棒TV看电影，分类很清晰，找片特别方便。客服响应也很快，有问题随时解决。',
      rating: 5,
    },
    {
      name: '赵女士',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20portrait%20photo%2C%20gentle%20smile%2C%20clean%20white%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-4&orientation=squarish',
      comment: '孩子特别喜欢看动漫频道，内容健康向上，家长放心。全家老小都能找到自己喜欢的节目。',
      rating: 5,
    },
  ],
  contact: {
    email: 'contact@bangbangtv.com',
    phone: '400-888-8888',
    address: '北京市朝阳区望京科技园区A座18层',
    wechat: 'bangbangtv_official',
    weibo: '@棒棒TV官方',
  },
};